import React from 'react'
import cn from 'classnames'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { clearCart } from '../actions/cart'
import { clearReceiptDetails } from '../actions/receipt'
import { getIsSuitesOrTabsMode } from '../selectors/config'

import ReceiptCard from '../components/receipt/ReceiptCard'
import ReceiptMenu from '../containers/receipt/ReceiptMenu'
import { ReactComponent as CloseIcon } from '../assets/icons/receipt-close-icon.svg'

import styles from './Receipt.module.scss'

const Receipt = ({ className, onClose, isSuitesOrTabsMode }) => {
  const classNames = cn(styles.receipt, className)

  return (
    <div className={classNames}>
      <div className={styles.receiptContent}>
        <ReceiptCard className={styles.receiptCard}/>
      </div>
      <ReceiptMenu className={styles.receiptMenu}/>
      <div className={styles.closeReceipt} onClick={() => onClose(isSuitesOrTabsMode)}>
        <CloseIcon />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const isSuitesOrTabsMode = getIsSuitesOrTabsMode(state)
  return { isSuitesOrTabsMode }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = get(ownProps, 'history.replace', () => {})

  return {
    onClose: (isSuitesOrTabsMode) => {
      dispatch(clearCart())
      dispatch(clearReceiptDetails())
      isSuitesOrTabsMode ? replace('/tabs') : replace('/')
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Receipt))
